// Debug logging utility that can be used across the application
export const debugLog = (...args) => {
    if (process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG === 'true') {
        console.log('[Debug]', ...args);
    }
}; 